import { useQuery } from "@tanstack/react-query";
import { Card } from "@/components/ui/card";
import { api } from "@/lib/api";
import { useWorkspace } from "./WorkspaceContext";

type Report = { sends: number; opened: number; completed: number };

export function ReportsTab() {
  const { campaignId } = useWorkspace();
  const { data } = useQuery({
    queryKey: ["workspace-reports", campaignId],
    queryFn: () => api.get<Report>(`/api/admin/campaigns/${campaignId}/reports`),
  });
  const r = data ?? { sends: 0, opened: 0, completed: 0 };
  const stats: ReadonlyArray<readonly [string, number]> = [
    ["Demo packs sent", r.sends],
    ["Opened", r.opened],
    ["Completed", r.completed],
  ];

  return (
    <div className="space-y-4">
      <div>
        <h2 className="font-head text-lg font-semibold">Reports</h2>
        <p className="text-xs text-muted-foreground">Delivery summary for this campaign's sends.</p>
      </div>
      <div className="grid grid-cols-3 gap-3 max-w-xl">
        {stats.map(([label, value]) => (
          <Card key={label} className="p-4">
            <div className="text-2xl font-semibold text-gold">{value}</div>
            <div className="text-xs text-muted-foreground mt-1">{label}</div>
          </Card>
        ))}
      </div>
    </div>
  );
}
